import {Form, FormField, FormSubmitHandler} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsFooter} from '@dms/settings/shared';
import {useBranches} from '@dms/shared';

import {GeneralTabFormType, generalTabFormSchema} from '../schemas/generalTabFormSchema';

interface GeneralTabProps {
  onSubmit: FormSubmitHandler<GeneralTabFormType>;
  isEditing?: boolean;
  defaultValues?: GeneralTabFormType;
  isLoading?: boolean;
}

export function GeneralTab(props: GeneralTabProps) {
  const branchesQuery = useBranches();

  return (
    <Form<GeneralTabFormType>
      defaultValues={props.defaultValues}
      experimentalZodSchema={generalTabFormSchema}
      onSubmit={props.onSubmit}
      shouldWatchForUnsavedChanges
    >
      {(control, _formApi, navigateWithoutBlocker) => (
        <VStack spacing={6}>
          <Grid columns={2}>
            <GridItem span={2}>
              <FormField
                type="text"
                control={control}
                name="name"
                label={i18n.t('general.labels.name')}
                isDisabled={props.isLoading}
                isRequired
              />
            </GridItem>
            <GridItem>
              <FormField
                type="choice"
                control={control}
                name="branchId"
                label={i18n.t('entity.branch.labels.branchId')}
                isDisabled={props.isLoading || branchesQuery.isLoading}
                options={branchesQuery.branchOptions}
                isRequired
              />
            </GridItem>
            <GridItem>
              <FormField
                type="text"
                control={control}
                name="storageLocationSeparator"
                label={i18n.t('entity.tireWarehouses.labels.separator')}
                tooltip={i18n.t('entity.tireWarehouses.labels.separatorTooltip')}
                isDisabled={props.isLoading}
                maxLength={1}
                isCounterVisible
              />
            </GridItem>
          </Grid>
          <SettingsFooter
            actions={[
              {
                type: 'button',
                title: props.isEditing
                  ? i18n.t('general.actions.discardChanges')
                  : i18n.t('general.actions.discard'),
                variant: 'secondary',
                onClick: () =>
                  props.isEditing
                    ? navigateWithoutBlocker(settingsRoutes.tireWarehouses)
                    : navigateWithoutBlocker(-1),
                isDisabled: props.isLoading,
              },
              {
                type: 'form-button',
                control,
                title: props.isEditing
                  ? i18n.t('general.labels.saveChanges')
                  : i18n.t('general.actions.save'),
                buttonType: 'submit',
                isDisabled: props.isLoading,
              },
            ]}
          />
        </VStack>
      )}
    </Form>
  );
}
